import type { SVGProps } from "react";
// generated from CurrencyDollar.svg — do not edit manually
// prettier-ignore
export default function CurrencyDollar(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 6 16 C 6 18.209 7.791 20 10 20 H 14 C 16.209 20 18 18.209 18 16 C 18 13.791 16.209 12 14 12 H 10 C 7.791 12 6 10.209 6 8 C 6 5.791 7.791 4 10 4 H 14 C 16.209 4 18 5.791 18 8 M 12 1 V 23" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
